"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoulDrainEffectHandler = exports.SoulDrainEffectArgs = void 0;
const DelayedDamage_1 = require("../../DelayedDamage");
const enums_1 = require("../../enums");
const core_1 = require("../../event-handlers/core");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EffectType_1 = require("../EffectType");
class SoulDrainEffectArgs {
    constructor(primaryAttribute, power) {
        this.primaryAttribute = primaryAttribute;
        this.power = power;
        this.__type = EffectType_1.EffectType.SoulDrain;
        this.__typeName = "SoulDrain";
        this.name = "SoulDrain";
        this.harmful = true;
    }
}
exports.SoulDrainEffectArgs = SoulDrainEffectArgs;
let SoulDrainEffectHandler = class SoulDrainEffectHandler {
    apply(sequence, container, state) {
        state.meta.ehId = container.registerEventHandler(state.targetId, state.duration.type === enums_1.DurationType.Ticks ? EventType_1.EventType.Tick
            : EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Unlimited, new core_1.RecurringDamageEventHandlerArgs(state.creatorId, Target_1.Target.Self, new DelayedDamage_1.DelayedDamage(state.args.__typeName, state.args.primaryAttribute, "Death", state.args.power)));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.ehId);
    }
};
SoulDrainEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.SoulDrain)
], SoulDrainEffectHandler);
exports.SoulDrainEffectHandler = SoulDrainEffectHandler;
